import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import { message } from "antd";
import ArrowPipeline from "./ArrowPipeline";
import { LeadUpdate } from '../../../../Api/Services/LeadApiServices';


const DealStageDemo = ({ UrlId, leadStatusData,setTrigger, displayData, getDetailsData, setNaCTrigger, UpdatePs, canUpdateDelete, successMessage, ApprovalMessage, AutomationMessage, setErrorData, setIsModalVisible1 }) => {
    const stages = leadStatusData.slice(0, 5);
    const extraStages = leadStatusData.slice(5);
    const [current, setCurrent] = useState();
    const [disabled, setDisabled] = useState(false);
    const onSubmit = async (id) => {
        setNaCTrigger("trigger")
        setTrigger("")
        setCurrent(id)
        let hideMessage;
        setDisabled(true)
        try {
            const payload = {
                leadStatusId: id
            }
            hideMessage = message.loading("Loading...", 0);
            const response = await LeadUpdate(payload, UrlId[1])
            if (response.status === 200) {
                if (Array.isArray(response.data) && response.data.length > 0 && response.data[0].entityType !== 'Success') {
                    setErrorData(response.data);
                    setIsModalVisible1(true);
                }
                else {
                    const isAutomation = response.data[0].message === AutomationMessage;
                    const isApproval = response.data[0].message === ApprovalMessage;
                    setDisabled(false)
                    hideMessage();
                    setNaCTrigger("CallBack")
                    setTrigger("activity")
                    if (isApproval) {
                        successMessage("Your action has triggered an approval process", "This record is now in the approval queue, and further changes are restricted until the approval process is complete", "Approve");
                    } else if (isAutomation) {
                        successMessage("Automation rule triggered", response.data[0].message);
                    } else {
                        message.success("Lead status updated successful");
                    }
                    getDetailsData(UrlId[1])
                }
            }
        }
        catch (error) {
            hideMessage();
            setDisabled(false)
            message.error(error)
        }
    }
    useEffect(() => {
        if (displayData) {
            setCurrent(displayData?.lead_status_id)
        }
    }, [displayData?.lead_status_id])
    return (
        <div>
            <div style={{
                fontSize: "16px",
                fontWeight: 600,
                marginBottom: "15px",
                display: "flex", alignItems: "center", gap: 5
            }}>
                Lead Status  <div className={`status-text Leadstatus${displayData?.lead_status_id}`} style={{ fontSize: 10 }}> {displayData?.leads_status_name}</div >
            </div>
            <ArrowPipeline
                stages={stages}
                currentStage={current === 6 || current === 7 || current === 8 ? null : current}
                onStageClick={(index) => onSubmit(index)}
                completedColor="#007bff"
                upcomingColor="#e0e0e0"
                textColor="#fff"
                arrowHeight={40}
                notchSize={6}
                disabledItem={disabled}
                UpdatePs={UpdatePs}
                canUpdateDelete={canUpdateDelete}
                displayData={displayData}
            />
            <div style={{
                marginTop: "10px",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                gap: 15
            }}>
                {extraStages.map((item) => {
                    const isCurrent = current === item.leadStatusId;
                    const canEdit = canUpdateDelete(UpdatePs.permission, UpdatePs.dataPermission, UpdatePs.type, UpdatePs.PId);
                    const isApprovedNone = displayData?.approved_for === "None";

                    return (
                        <div
                            key={item.leadStatusId}
                            className={
                                isCurrent
                                    ? "status-upadte-arrow-selected"
                                    : !canEdit
                                        ? "status-upadte-arrow2"
                                        : isApprovedNone
                                            ? "status-upadte-arrow"
                                            : "status-upadte-arrow2"
                            }
                            role="button"
                            tabIndex={0}
                            style={{
                                cursor:
                                    isCurrent
                                        ? "default"
                                        : !canEdit
                                            ? "default"
                                            : isApprovedNone
                                                ? (disabled ? "default" : "pointer")
                                                : "default"
                            }}
                            onClick={() => {
                                if (isCurrent || !canEdit || !isApprovedNone || disabled) return;
                                onSubmit(item.leadStatusId);
                            }}
                            onKeyDown={(event) => {
                                if (
                                    isCurrent ||
                                    !canEdit ||
                                    !isApprovedNone ||
                                    disabled
                                ) return;

                                if (event.key === 'Enter' || event.key === ' ') {
                                    onSubmit(item.leadStatusId);
                                }
                            }}
                        >
                            {item.leadStatusName}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

DealStageDemo.propTypes = {
    UrlId: PropTypes.array.isRequired,
    getDetailsData: PropTypes.func.isRequired,
    setNaCTrigger: PropTypes.func.isRequired,
    leadStatusData: PropTypes.array.isRequired,
    displayData: PropTypes.object.isRequired,
    UpdatePs: PropTypes.object.isRequired,
    canUpdateDelete: PropTypes.func.isRequired,
    successMessage: PropTypes.func.isRequired,
    ApprovalMessage: PropTypes.string.isRequired,
    AutomationMessage: PropTypes.string.isRequired,
    setErrorData: PropTypes.func.isRequired,
    setIsModalVisible1: PropTypes.func.isRequired,
    setTrigger: PropTypes.func.isRequired,
};

export default React.memo(DealStageDemo)
